export enum SidebarType {
  APP = 'APP',
}

export interface Sidebar {
  type: SidebarType
  params?: { [key: string]: string | number | boolean | null }
}
